export const MENU_TOGGLE_STATE_LANGUAGE = {
    english: { expand: 'Expand Menu', collapse: 'Collapse Menu' },
    spanish: { expand: 'Expandir Menú', collapse: 'Colapso Menú' },
    hindi: { expand: 'विस्तार सूची', collapse: 'संक्षिप्त सूची' }
};